import React from 'react'
import getSelectionCoords from '@aytm/lib/rfd-ui/components/advanced/lib/draft-js/suggestionsPlugin/lib/get-selection-coords'
import SuggestionsComponent from '@aytm/lib/rfd-ui/components/advanced/lib/draft-js/suggestionsPlugin/components/Suggestions'
import SuggestionItem from './SuggestionItem'
import styles from '@aytm/lib/rfd-ui/styles/SuggestionsComponent.module.scss'

const DROPDOWN_OFFSET_Y = 24

export default class CustomSuggestionsComponent extends SuggestionsComponent {
  constructor(...args) {
    super(...args);
    this.handleScroll = this.handleScroll.bind(this);
    this.selectSuggestion = this.selectSuggestion.bind(this);
    this.updateItems = this.updateItems.bind(this);
    this.calculatePortalStyles = this.calculatePortalStyles.bind(this);
    this.renderDropdown = this.renderDropdown.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    super.componentDidUpdate(prevProps, prevState, snapshot)
    if (prevState.visibility !== this.state.visibility) {
      if (this.state.visibility) {
        window.addEventListener('scroll', this.handleScroll)
      } else {
        window.removeEventListener('scroll', this.handleScroll)
      }
    }
  }

  componentDidMount() {
    super.componentDidMount()
    if (this.state.visibility) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount()
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    this.updatePosition()
  }

  selectSuggestion(suggestion) {
    const { selectSuggestion, onBeforeSelect } = this.props

    onBeforeSelect(suggestion)
    selectSuggestion(suggestion)
  }

  updateItems(items, visibility) {
    const { fuzzyItems, nonFuzzyItems } = items.reduce(
      (accumulator, item) => {
        const group = item.fuzzy ? 'fuzzyItems' : 'nonFuzzyItems'
        accumulator[group].push(item)
        return accumulator
      },
      { fuzzyItems: [], nonFuzzyItems: [] }
    )

    const sortedFuzzyItems = fuzzyItems.sort((a, b) => a.fuzzyIndexOf || 0 - b.fuzzyIndexOf || 0)

    super.updateItems([...sortedFuzzyItems, ...nonFuzzyItems], visibility)
  }

  calculatePortalStyles(items = [], props) {
    if (this.refItems.current) {
      const itemsElement = this.refItems.current
      const itemsElementRects = itemsElement.getClientRects()

      if (itemsElementRects && itemsElementRects[0]) {
        const selectionCoords = getSelectionCoords()
        const dropdownOffsetLeft = this.calculateDropdownOffsetLeft({
          items,
          itemsElementRects,
          selectionCoords,
          props
        })

        return {
          position: 'fixed',
          left: Math.floor(selectionCoords.x + dropdownOffsetLeft),
          top: Math.floor(selectionCoords.y + DROPDOWN_OFFSET_Y)
        }
      }
    }

    return {
      visibility: 'hidden',
      x: 0,
      y: 0
    }
  }

  renderDropdown() {
    return (
      <div className={styles.items} ref={this.refItems}>
        {this.state.items.map((suggestion, index) => (
          <div
            key={index}
            onMouseMove={this.createSuggestionMouseHandler(index)}
            onMouseEnter={this.createSuggestionMouseHandler(index)}
          >
            <SuggestionItem
              key={index}
              index={index}
              selectSuggestion={this.selectSuggestion}
              selectedIndex={this.state.selectedIndex}
              suggestion={suggestion}
            />
          </div>
        ))}
      </div>
    )
  }
}
